export default __webpack_public_path__ + "static/media/etc00.80bdaa8a.png";